export default __webpack_public_path__ + "static/media/Epic__xvid.d15929ea.6ad07379.webp";